import {getData, postData} from './redux_data';
import {
    GET_FAMILIA,
    MODIFY_FAMILIA,
    ADD_FAMILIA,
    DELETE_FAMILIA,
    UPDATE_FAMILIA,
} from '../constants/action_types';

export function getFamilia() {
    return getData('CvFamilias', GET_FAMILIA);
}

export function modifyFamilia(familia) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_FAMILIA, payload: familia });
    }
}

export function addFamilia(familia) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_FAMILIA, payload: familia });
    }
}

export function removeFamilia(familia) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_FAMILIA, payload: familia });
    }
}

export function updateFamiliaDB (familia) {
    return postData('CvFamilias/grupos', UPDATE_FAMILIA, familia, 'Familias actualizadas', undefined);

}

